import React from 'react';

interface JunctionProps {
    x: number;
    y: number;
    color?: string; // Default #1a1a1a (Black)
    label?: string;
    labelOffset?: number; // Distance from center
    labelPosition?: 'top' | 'bottom' | 'left' | 'right' | 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
}

export const Junction: React.FC<JunctionProps> = ({
    x,
    y,
    color = "#1a1a1a",
    label,
    labelOffset = 15,
    labelPosition = 'top-right'
}) => {
    let dx = 0;
    let dy = 0;

    // Calculate offsets based on position
    switch (labelPosition) {
        case 'top': dy = -1; break;
        case 'bottom': dy = 1; break;
        case 'left': dx = -1; break;
        case 'right': dx = 1; break;
        case 'top-left': dx = -0.707; dy = -0.707; break;
        case 'top-right': dx = 0.707; dy = -0.707; break;
        case 'bottom-left': dx = -0.707; dy = 0.707; break;
        case 'bottom-right': dx = 0.707; dy = 0.707; break;
    }

    const lx = x + dx * labelOffset;
    const ly = y + dy * labelOffset;

    return (
        <g>
            <circle cx={x} cy={y} r={4} fill={color} />
            {label && (
                <text
                    x={lx}
                    y={ly}
                    fill={color}
                    fontSize="14"
                    fontWeight="500"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    style={{ textShadow: '0 0 4px white' }}
                >
                    {label}
                </text>
            )}
        </g>
    );
};
